'use client';

import { useRouter } from '@/i18n/navigation';
import { getToken } from '@/lib/auth-token';
import { useEffect } from 'react';

export const CheckLogin = () => {
  const router = useRouter();

  useEffect(() => {
    getToken().then((token) => {
      if (!token) {
        return;
      }

      router.replace(`/treatments`);
    });
  }, [router]);

  return null;
};
